import { render, staticRenderFns } from "./ShopCategorys.vue?vue&type=template&id=766876f0&"
import script from "./ShopCategorys.vue?vue&type=script&lang=js&"
export * from "./ShopCategorys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports